import { graphql } from 'react-relay';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

export const preloadPersonalSpaceDetailsQuery = graphql`
	query preloadPersonalSpaceDetailsQuery {
		user: confluence_atlassianUser(current: true) {
			id
			confluence {
				space {
					id
					key
					dataClassificationTags
				}
			}
		}
	}
`;

export const preloadPersonalSpaceDetail = () => {
	return query({
		query: preloadPersonalSpaceDetailsQuery,
	});
};
